module.exports = __webpack_public_path__ + "./hannah-illustration_90c2ae768be537a57acb3b2d12d2f554.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2014/hannah-illustration.png
// module id = 414
// module chunks = 0